import { ComponentConfigType } from '../../utils/data-parser';
import { ComponentType, type IConfig } from '../../types';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.FormSwitch,
  configGroups: [
    {
      title: 'Component Settings',
      items: [
        {
          name: 'disabled',
          label: 'Disabled',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'checked',
          label: 'Checked',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'loading',
          label: 'Loading',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'size',
          label: 'Size',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Default', value: 'default' },
              { label: 'Small', value: 'small' },
            ],
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },
  ],
};
